import * as React from 'react';
import CirclePlusOutlined from './circle-plus-outlined';
import CirclePlusFilled from './circle-plus-filled';
import type { IconCombinedProps } from './types';
const CirclePlusCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <CirclePlusFilled ref={ref} {...rest} />;
  }
  return <CirclePlusOutlined ref={ref} {...rest} />;
});
export default CirclePlusCombined;